import React from 'react';

type CFLogoProps = {
  width?: number; // Optional width prop
};

export const CFLogo: React.FC<CFLogoProps> = ({ width = 130 }) => {
  return <img src="/images/logo-black.svg" alt="cf-logo" width={width} />;
};
